/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/use-brace-expansion */
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import Predicate from 'predicates/models/predicate';
import { computed } from '@ember/object';
export default Predicate.extend({
  attribute: null,
  value: null,
  comparison: null,
  isEditable: false,
  isLogicalType: true,
  genericType: 'logical',
  predicates: fragmentArray('predicates/predicate', {
    polymorphic: true,
    typeKey: 'subclass'
  }),
  isValid: computed('predicates.[]', 'predicates.@each.isValid', function () {
    return this.predicates.isEvery('isValid', true) && this.predicates.isEvery('isRoot', false);
  }),
  toggleAndOr() {
    let type = this.type;
    if (type === 'or') {
      type = 'and';
    } else if (type === 'and') {
      type = 'or';
    } else {
      throw new Error('Unsupported type');
    }
    this.set('type', type);
  }
});